'use client';

import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { forwardRef } from 'react';
import { useNotifications } from '@module/mdrt-org/shared/components/providers/notifications-context';
import { NotificationsBellIcon } from '@shared/ui-components/svgs';
import styles from './notifications-button.module.scss';
type NotificationsButtonProps = {
  onClick: () => void;
};
const PARENT_CLASSNAME = 'notifications-button';
export const NotificationsButton = forwardRef<HTMLButtonElement, NotificationsButtonProps>((t0, ref) => {
  const $ = _c(8);
  const {
    onClick
  } = t0;
  const {
    allNotificationsAreRead,
    cmsContent
  } = useNotifications();
  const t1 = cmsContent.notificationsDropdownTriggerLabel;
  const t2 = !allNotificationsAreRead;
  let t3;
  if ($[0] !== t2) {
    t3 = classnames(styles[PARENT_CLASSNAME], {
      [styles[`${PARENT_CLASSNAME}--new`]]: t2
    });
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={styles[`${PARENT_CLASSNAME}__icon-wrapper`]}><NotificationsBellIcon /></div>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== cmsContent.notificationsDropdownTriggerLabel || $[4] !== onClick || $[5] !== ref || $[6] !== t3) {
    t5 = <button aria-label={t1} className={t3} data-ga-exclude-tracking={true} onClick={onClick} ref={ref} type="button">{t4}</button>;
    $[3] = cmsContent.notificationsDropdownTriggerLabel;
    $[4] = onClick;
    $[5] = ref;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
});